import React from 'react';
import { useDismissForever, Clickable } from '@routable/gross-ds';
import { SectionMessage } from '../SectionMessage';
export const DismissibleSectionMessage = ({ dismissedId, children, title }) => {
    const { isDismissed, updateDismissedForever } = useDismissForever(dismissedId);
    if (isDismissed) {
        return null;
    }
    return (React.createElement(SectionMessage, { customAction: React.createElement(Clickable, { className: "inline-block w-max text-sm font-medium", onClick: updateDismissedForever, variant: "black" }, "Don't remind me again"), title: title }, children));
};
